<template>
  <div>
    <div>
      <NotificationMessage v-if="showNotification" :message="notificationMessage" :type="notificationType" :duration="5000"/>
    </div>

    <b-row no-gutters>
      <b-col lg="8" md="6">
        <b-card-text>
            <div class="titres pr-2" align ="left" >{{requeteData.titre}}</div>
            <p align="left" class="sousTitre" v-if="requeteData.keywords!==0">mots clés : {{requeteData.keywords}}</p>
            <p align="left" class="sousTitre" v-else>mots clés : Aucun mots clés enregistrés</p>
        </b-card-text>
      </b-col>
      <b-button pill align-self="center" id="showRequete"
        title="visualiser les informations de la requête" @click.prevent="showModalAfficherRequete = !showModalAfficherRequete; showModalModifierRequete=false" class="nav-link1">visualiser <i class="fas fa-eye"></i>
      </b-button>
      <b-button pill align-self="center" id="modifRequete"
        title="modifier la requête" @click.prevent="showModalModifierRequete = !showModalModifierRequete;showModalAfficherRequete=false" class="nav-link4">modifier <i class="fas fa-pencil-alt"></i>
      </b-button>
      <b-button pill align-self="center" id="supprRequete"
        title="supprimer la requête" @click.prevent="deleteRequete" class="nav-link2">supprimer <i class="fas fa-trash-alt"></i>
      </b-button>
    </b-row>

    <div class ="item">   
      <b-col class="mb-2 mt-1 requetes">
        <div id="afficher" v-if="showModalAfficherRequete">
          <form>
            <ModalAfficherRequete :id="requeteData.idRequete" :lectureSeule="lectureSeule" v-if="showModalAfficherRequete"
              @close="showModalAfficherRequete = false" class="center"></ModalAfficherRequete>
          </form>
        </div>

        <div id="modif" v-if="showModalModifierRequete">
              <ModalModifierRequete :idRequetes="requeteData.idRequete" :lectureSeule="!lectureSeule" v-if="showModalModifierRequete"
                @close="showModalModifierRequete = false" @notification="handleNotification" class="center">
              </ModalModifierRequete>
        </div>
      </b-col>
    </div>
  </div>
</template>

<script>
import {onMounted, ref} from 'vue';
import http from '@/http.js'
import eventBus from '@/eventBus.js'
import NotificationMessage from "@/components/Notification.vue"
import ModalModifierRequete from '@/components/Requete/ModalModifierRequete.vue'
import ModalAfficherRequete from '@/components/Requete/ModalAfficherRequete.vue'


export default {
    name:"RequetesItemAccordion",
    components:{
      ModalModifierRequete,
      ModalAfficherRequete,
      NotificationMessage,
    },
    props:{
        requeteData:{
            type:Object,
            required:true
        },

        lectureSeule:{
        type:Boolean,
        default:true
      }
    },
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup(props){
    const showModalModifierRequete = ref(false);
    const showModalAfficherRequete = ref(false);
    const showNotification = ref(false);
    const notificationMessage = ref("");
    const notificationType = ref("info");

    const handleNotification = ({ toastMessage, toastType }) => {
      notificationMessage.value = toastMessage;
      notificationType.value = toastType;
      showNotification.value = true;
      setTimeout(() => {
        showNotification.value = false;
      }, 5000);
    };
    eventBus.on("notification", handleNotification);

    const deleteRequete = async () => {
      const data = await http.verifBeforeDelete(props.requeteData.idRequete);
      if (data === false) {
        if (confirm(`Voulez-vous vraiment supprimer la requête : ${props.requeteData.idRequete}`)) {
          try{
            await http.deleteRequete(props.requeteData.idRequete);
            eventBus.emit('reloadRequetes');
            window.scrollTo(0, 0);
            eventBus.emit("notification", {
              toastMessage: "Requete supprimée avec succès",
              toastType: "success"
            });
          }catch (error) {
            eventBus.emit("notification", {
              toastMessage: "Erreur lors de la suppression de l'application",
              toastType: "danger"
            });
          }
        }
      }else{
        eventBus.emit("notification", {
          toastMessage: "Impossible d'effacer cette requête car elle est contenue dans un jeu",
          toastType: "danger"
        });
      }
    };


    onMounted(() => {
      eventBus.on('modifierRequete', deleteRequete);
    });
    return {
      showModalModifierRequete,
      showModalAfficherRequete,
      deleteRequete,
      showNotification,
      notificationMessage,
      notificationType,
      handleNotification

    };
  }
};
</script>

<style>

.titres{
color: white;
}
.sousTitre{
    color: white;
}

</style>